<script>
import CardWrapper from '@/Shared/CardWrapper';
import CardLayout from '@/Shared/CardLayout';
import FlashMessages from '@/Shared/FlashMessages';
import UploadsList from '@/Pages/EmployeesImport/components/UploadsList'
import ImportDetails from '@/Pages/EmployeesImport/components/ImportDetails'
import { formatDateToPeriod } from '@/utils/date'
import { truncateText } from '@/utils/string'

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/employees-import/show.title', {
                period: this.formattedEmployeeImportPeriod,
            }),
        }
    },

    components: {
        CardWrapper,
        CardLayout,
        FlashMessages,
        ImportDetails,
        UploadsList,
    },

    props: {
        allEmployeeImportFiles: Object,
        employeeImport: Object,
        employeeImportFile: Object,
        uploadFeatureEnabled: Boolean,
    },

    methods: {
        truncateText,

        setActiveFile(fileUuid) {
            this.$inertia.visit(route('nl.employerdashboard.employees-import.file.show', {
                company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                employeeImport: this.employeeImport.data.uuid,
                employeeImportFile: fileUuid,
            }));
        },
    },

    computed: {
        formattedEmployeeImportPeriod() {
            return formatDateToPeriod(this.employeeImport.data.reference_date)
        },

        currentFileIsLatest() {
            const lastIndex = this.allEmployeeImportFiles.data.length - 1

            return this.allEmployeeImportFiles.data[lastIndex].uuid === this.employeeImportFile.data.uuid
        },
    },
}
</script>

<template>
    <card-wrapper
        :title="Lang.get('employerdashboard::pages/employees-import/show.title', {
            period: formattedEmployeeImportPeriod,
        })"
        :subtitle="Lang.get('employerdashboard::pages/employees-import/show.subtitle')">

        <template v-slot:nav aria-label="breadcrumb">
            <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-transparent">
                <li class="breadcrumb-item" aria-current="page">
                    <inertia-link class="font-weight-semibold color-blue" :href="route('nl.employerdashboard.employees-import.overview', {
                        company_as_uuid: $page.props.auth.user.selected_company.uuid,
                    })">
                        {{ Lang.get('employerdashboard::pages/employees-import/index.title') }}
                    </inertia-link>
                </li>

                <li class="breadcrumb-item color-blue" aria-current="page">
                    {{ truncateText(employeeImportFile.data.original_filename, 60) }}
                </li>
            </ol>
        </template>

        <div class="col-12">
            <flash-messages :hideErrors="true"></flash-messages>
        </div>

        <card-layout card-padding="p0 pb-4">
            <div class="row">
                <div class="col-3">
                    <UploadsList :employee-import-files="allEmployeeImportFiles"
                                 :active-file="employeeImportFile.data.uuid"
                                 @file-selected="setActiveFile"/>
                </div>

                <div class="col-9">
                    <ImportDetails
                        :employee-import="employeeImport.data"
                        :employee-import-file="employeeImportFile.data"
                        :company-uuid="$page.props.auth.user.selected_company.uuid"
                        :is-latest-file="currentFileIsLatest"
                        :is-authorized-from-scp="$page.props.auth.isAuthorizedFromScp"
                        :upload-feature-enabled="uploadFeatureEnabled"
                    />
                </div>
            </div>
        </card-layout>
    </card-wrapper>
</template>
